/*
  HALO Bateria: anima o contador de dias e a revelação da faixa (seção HALO Bateria).
  Tudo é guiado por um progresso p de 0 a 1, aplicado em CSS por variáveis (--hb-p e --hb-q).
  Sem JavaScript, ou com movimento reduzido, o HTML já mostra o estado final.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-bateria-anim')) return;

  function clamp01(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isFinite(n) ? n : fallback;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  class HaloBateriaAnim extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.countEl = this.querySelector('[data-count]');
      this.unitEl = this.querySelector('[data-unit]');
      this.from = toInt(this.dataset.from, 1);
      this.to = toInt(this.dataset.to, 7);
      this.duration = Math.max(300, toInt(this.dataset.duration, 2200));
      this.mode = this.dataset.mode === 'scroll' ? 'scroll' : 'appear';
      this.circular = this.dataset.circular === 'true';
      this.section = this.closest('.halo-bateria');
      this.circle = this.querySelector('.halo-bateria__circle');
      this.replay = this.dataset.replay === 'true';
      this.raf = 0;
      this.played = false;
      this.lastCount = null;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        this.disconnectedCallback();
        this.connectedCallback();
      };
      this.motionQuery.addEventListener('change', this.onMotionChange);
      if (!this.countEl || this.motionQuery.matches || !('IntersectionObserver' in window)) {
        if (this.countEl) this.set(1);
        return;
      }

      this.classList.add('is-armed');
      this.set(0);

      var self = this;
      if (this.mode === 'scroll') {
        this.onScroll = function () {
          if (!self.raf) self.raf = requestAnimationFrame(self.fromScroll.bind(self));
        };
        this.io = new IntersectionObserver(function (entries) {
          var inView = entries[entries.length - 1].isIntersecting;
          if (inView) {
            window.addEventListener('scroll', self.onScroll, { passive: true });
            self.onScroll();
          } else {
            window.removeEventListener('scroll', self.onScroll);
          }
        });
        window.addEventListener('resize', this.onScroll, { passive: true });
        window.addEventListener('pageshow', this.onScroll);
        this.onScroll();
      } else {
        this.io = new IntersectionObserver(
          function (entries) {
            var entry = entries[entries.length - 1];
            if (entry.isIntersecting && !self.played) {
              self.play();
            } else if (!entry.isIntersecting && self.replay && entry.boundingClientRect.top > 0) {
              // Saiu por baixo: volta ao início para tocar de novo quando reaparecer.
              self.stop();
              self.played = false;
              self.set(0);
            }
          },
          { threshold: 0.35 }
        );
      }
      this.io.observe(this.circular ? this.section : this);

      // Editor de temas: ao selecionar a seção, a animação toca de novo.
      this.onSectionSelect = function (e) {
        if (self.mode !== 'appear' || e.detail.sectionId !== self.dataset.sectionId) return;
        self.stop();
        self.played = false;
        self.play();
      };
      document.addEventListener('shopify:section:select', this.onSectionSelect);
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onScroll) window.removeEventListener('resize', this.onScroll);
      if (this.onScroll) window.removeEventListener('pageshow', this.onScroll);
      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
      this.classList.remove('is-armed');
      if (this.onSectionSelect) document.removeEventListener('shopify:section:select', this.onSectionSelect);
    }

    play() {
      this.played = true;
      var self = this;
      var start = performance.now();
      var tick = function (now) {
        var t = clamp01((now - start) / self.duration);
        self.set(easeOutCubic(t));
        self.raf = t < 1 ? requestAnimationFrame(tick) : 0;
      };
      this.stop();
      this.raf = requestAnimationFrame(tick);
    }

    stop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    // Modo rolagem: começa quando o topo da seção chega a 85% da tela e termina em 25%.
    // Círculo: rola junto com a página (sem prender na tela). Começa quando o topo do círculo
    // chega a 85% da tela e completa quando o centro dele chega ao meio; ao subir, volta.
    fromScroll() {
      this.raf = 0;
      var vh = window.innerHeight || 1;
      if (this.circular && this.circle) {
        var rect = this.circle.getBoundingClientRect();
        var startTop = vh * 0.85;
        var endTop = vh * 0.5 - rect.height / 2;
        this.set(clamp01((startTop - rect.top) / Math.max(1, startTop - endTop)));
        return;
      }
      var top = this.getBoundingClientRect().top;
      this.set(clamp01((vh * 0.85 - top) / (vh * 0.6)));
    }

    set(p) {
      this.style.setProperty('--hb-p', p.toFixed(4));
      this.style.setProperty('--hb-dash', ((1 - p) * 100).toFixed(4) + 'px');
      this.style.setProperty('--hb-q', clamp01(p * 2.5).toFixed(4));
      var count = Math.round(this.from + (this.to - this.from) * p);
      if (count !== this.lastCount) {
        this.lastCount = count;
        this.countEl.textContent = count;
        if (this.unitEl && this.unitEl.dataset.singular) {
          this.unitEl.textContent = count === 1 ? this.unitEl.dataset.singular : this.unitEl.dataset.plural;
        }
      }
    }
  }

  customElements.define('halo-bateria-anim', HaloBateriaAnim);
})();
